import { getClientService } from 'components/ClientIdCombo/services/ClientIdComboServices';
import businessListServices from 'components/BusinessList/services/BusinessListServices';
import { findIndex, clone } from 'lodash';
import { serviceCallListApi, serviceSetRelatedServiceApi } from '../../services/WebServiceServices';

class generateEdit {
  resWebService;

  resServiceSet;

  constructor(id) {
    this.id = id;
  }

  async getWebService() {
    this.resWebService = await serviceCallListApi({ id: this.id });
  }

  async getServiceSet() {
    this.resServiceSet = await serviceSetRelatedServiceApi(this.id);
  }

  async getData() {
    await this.getWebService();
    await this.getServiceSet();

    let clientIdSelected = {};

    let dataServiceCall = this.resWebService.result[0];

    let dataServiceSet = this.resServiceSet.result.rows.length
      ? this.resServiceSet.result.rows
      : [];
    if (dataServiceSet.length > 0) {
      dataServiceSet = dataServiceSet.map((item) => ({
        name: item.cols[1],
        id: item.cols[0],
      }));
    }

    if (dataServiceCall.scClientId && dataServiceCall.scAutoApprove === true) {
      const clientIDResult = await getClientService();
      const clientIDList = clientIDResult.result.clients;

      clientIdSelected = clientIDList.filter(
        (item) => item.client_id === dataServiceCall.scClientId,
      );

      clientIdSelected = {
        name: clientIdSelected[0].name,
        client_id: clientIdSelected[0].client_id,
      };
    }

    if (dataServiceCall?.scStakeholderList && dataServiceCall.scStakeholderList.length > 0) {
      const businessId = dataServiceCall.scStakeholderList.map((item) => item.businessId).join(',');

      const resultB = await businessListServices.getBusinessList({
        businessId,
      });

      const list = resultB.result;

      const business = {};
      list.forEach((element) => {
        business[element.id] = element.name;
      });

      const stackSelected = dataServiceCall.scStakeholderList.map((item) => ({
        ...item,
        businessId: {
          name: business[item.businessId],
          id: item.businessId,
        },
      }));

      dataServiceCall.scStakeholderList = stackSelected;
    }

    let headers = [];
    let contentType = {};
    if (dataServiceCall?.scHeaderParams) {
      headers = clone(dataServiceCall.scHeaderParams);

      const indexContentType = findIndex(headers, {
        scParameterName: 'content-type',
        scParameterDesc: '',
        scIsRequired: false,
        scHiddenParameter: true,
        scParameterLogMode: 'LOGGABLE',
      });

      if (indexContentType > -1) {
        contentType = headers[indexContentType];

        headers.splice(indexContentType, 1);
      }
    }

    if (dataServiceCall?.providerBusiness) {
      const providerBusinessId = {
        id: dataServiceCall?.providerBusiness.id,
        name: dataServiceCall?.providerBusiness.name,
      };

      dataServiceCall = {
        ...dataServiceCall,
        providerBusinessId,
      };
    }

    const webService = {
      ...dataServiceCall,
      scFaName: dataServiceCall.name,
      scType: dataServiceCall.scType.toUpperCase(),
      scAutoApprove: dataServiceCall.scAutoApprove ? 'true' : 'false',
      scHttpStatusCode: dataServiceCall?.scSuccessfulResult?.scHttpStatusCode,
      scHttpResponse: dataServiceCall?.scSuccessfulResult?.scHttpResponse,
      serviceSet: dataServiceSet,
      scHeaderParams: headers,
      currentVersion: dataServiceCall.serviceVersion,
      contentType: contentType?.scParameterDefaultValue,
      scGuildCode: {
        name: dataServiceCall.guild.name,
        code: dataServiceCall.guild.code,
      },
      // scInputParams: dataServiceCall.scInputParams,
    };

    if (webService?.scHttpVerb) {
      webService.scHttpVerb = webService.scHttpVerb.toUpperCase();
    }

    if (webService.scAutoApprove === 'true') {
      webService.scClientId = {
        client_id: clientIdSelected.client_id,
        name: clientIdSelected.name,
      };
    }
    return webService;
  }
}

export default generateEdit;
